import { CreateFarmPrimaryDataQueryParams, axios } from "utils";

import { ADMIN_FOOTPRINTING_URL } from "consts";

import {
  BeefFeedProduction,
  BeefFootprintReturnBody,
  CalculatedBeefFootprintResponse,
  CalculatedCropFootprintResponse,
  CalculatedDairyFootprintResponse,
  CalculatedFarmFootprintResponse,
  CalculatedPigletFootprintResponse,
  CalculatedPorkFootprintResponse,
  CropFootprintReturnBody,
  CropSaleData,
  DairyFeedProduction,
  DairyFootprintReturnBody,
  EmissionsFactorRefrigerant,
  FarmFootprintReturnBody,
  FarmLandUseChange,
  FootprintingBeefFeedInformation,
  FootprintingBeefGrasslandFertiliser,
  FootprintingBeefGrasslandFertiliserPayload,
  FootprintingBeefHerdDetails,
  FootprintingBeefHerdSize,
  FootprintingBeefManureAdditivePayload,
  FootprintingBeefPrimaryData,
  FootprintingCropDrying,
  FootprintingCropFertilizer,
  FootprintingCropPrimaryData,
  FootprintingCropSalesPayload,
  FootprintingCropSeeding,
  FootprintingCropTillage,
  FootprintingDairyCowSales,
  FootprintingDairyFeedAdditivePayload,
  FootprintingDairyFeedInformation,
  FootprintingDairyGrasslandFertiliserPayload,
  FootprintingDairyHerdDetails,
  FootprintingDairyHerdSize,
  FootprintingDairyManureAdditivePayload,
  FootprintingDairyManureStoragePayload,
  FootprintingDairyPrimaryData,
  FootprintingDairyRefrigerantUsage,
  FootprintingFarmCropPlantProtectionPayload,
  FootprintingFarmPrimaryData,
  FootprintingFarmResourceConsumption,
  FootprintingPigletFeedInformation,
  FootprintingPigletHerdDetails,
  FootprintingPigletManureAdditivePayload,
  FootprintingPigletManureStoragePayload,
  FootprintingPigletPrimaryData,
  FootprintingPigletStablesPayload,
  FootprintingPorkFeedInformation,
  FootprintingPorkHerdDetails,
  FootprintingPorkManureAdditivePayload,
  FootprintingPorkManureStoragePayload,
  FootprintingPorkPigletSourcingPayload,
  FootprintingPorkPrimaryData,
  FootprintingPorkStablesPayload,
  LandUseChangeRequestPayload,
  PigletFeedProduction,
  PigletFootprintReturnBody,
  PorkFeedProduction,
  PorkFootprintReturnBody,
  PurchaserData,
  UploadableBeefFeedAdditive,
  UploadableBeefFeedInformation,
  UploadableBeefHerdSize,
  UploadableBeefManureStorage,
  UploadableCowSales,
  UploadableFeedAdditive,
  UploadableFeedInformation,
  UploadableGrasslandFertiliser,
  UploadableHerdSize,
  UploadableManureAdditive,
  UploadableManureStorage,
  UploadablePigletFeedInformation,
  UploadablePlantProtection,
  UploadablePorkFeedInformation,
  UploadableRefrigerant,
} from "models";

export const getCalculatedFarmFootprintByYearAdmin = async (farmId: string, year: number): Promise<CalculatedFarmFootprintResponse> =>
  // @ts-expect-error custom params can be passed in axios config
  axios.get(`${ADMIN_FOOTPRINTING_URL}/farm-footprints/footprint-calculation`, { data: { farmId, year }, hideErrorMessage: true });

export const getCalculatedCropFootprintByCropIdAndYearAdmin = async (farmId: string, year: number, cropId: string): Promise<CalculatedCropFootprintResponse> =>
  // @ts-expect-error custom params can be passed in axios config
  axios.get(`${ADMIN_FOOTPRINTING_URL}/crop-footprints/footprint-calculation`, { data: { farmId, cropId, year }, hideErrorMessage: true });

export const getFarmFootprintByYearAdmin = async (farmId: string, year: number): Promise<FarmFootprintReturnBody> =>
  // @ts-expect-error custom params can be passed in axios config
  axios.get(`${ADMIN_FOOTPRINTING_URL}/farm-footprints`, { data: { farmId, year }, hideErrorMessage: true });

export const getFootprintingFarmFootprintsByPrimaryDataIdAdmin = async (primaryDataId: string): Promise<FarmFootprintReturnBody> =>
  // @ts-expect-error custom params can be passed in axios config
  axios.get(`${ADMIN_FOOTPRINTING_URL}/farm-footprints/${primaryDataId}`, { hideErrorMessage: true });

export const getFootprintingCropFootprintByPrimaryDataIdAdmin = async (primaryDataId: string): Promise<CropFootprintReturnBody> =>
  // @ts-expect-error custom params can be passed in axios config
  axios.get(`${ADMIN_FOOTPRINTING_URL}/crop-footprints/${primaryDataId}`, { hideErrorMessage: true });

export const getCropFootprintByCropIdAndYearAdmin = async (farmId: string, year: number, cropId: string): Promise<CropFootprintReturnBody> =>
  // @ts-expect-error custom params can be passed in axios config
  axios.get(`${ADMIN_FOOTPRINTING_URL}/crop-footprints`, { data: { farmId, year, cropId }, hideErrorMessage: true });

export const getFootprintingCropPlantProtectionAdmin = async (primaryDataId: string): Promise<UploadablePlantProtection[]> =>
  axios.get(`${ADMIN_FOOTPRINTING_URL}/crop-footprints/${primaryDataId}/plant-protection`);

export const getAdminCropFootprints = async (farmId: string, year: number, cropId: string): Promise<CropFootprintReturnBody> =>
  axios.get(`${ADMIN_FOOTPRINTING_URL}/crop-footprints`, { data: { farmId, year, cropId } });

export const getFootprintingFarmResourceConsumptionByPrimaryDataIdAdmin = async (
  footprintingFarmPrimaryDataId: string
): Promise<FootprintingFarmResourceConsumption> =>
  axios.get(`${ADMIN_FOOTPRINTING_URL}/farm-footprints/resource-consumption`, { data: { footprintingFarmPrimaryDataId } });

export const getFootprintingEmissionFactorsRefrigerantsAdmin = async (): Promise<EmissionsFactorRefrigerant[]> =>
  axios.get(`${ADMIN_FOOTPRINTING_URL}/emission-factors/refrigerants`);

export const getFarmLandUseChangesAdmin = async (farmId: string, year?: number, range?: number): Promise<FarmLandUseChange[]> =>
  axios.get(`${ADMIN_FOOTPRINTING_URL}/farm-footprints/${farmId}/land-use-change?year=${year ?? ""}&range=${range ?? ""}`);

export const getFootprintingCropDryingsByPrimaryDataIdAdmin = async (primaryDataId: string): Promise<FootprintingCropDrying[]> =>
  axios.get(`${ADMIN_FOOTPRINTING_URL}/crop-footprints/${primaryDataId}/dryings`);

export const getFootprintingCropSeedingsByPrimaryDataIdAdmin = async (primaryDataId: string): Promise<FootprintingCropSeeding[]> =>
  axios.get(`${ADMIN_FOOTPRINTING_URL}/crop-footprints/${primaryDataId}/seedings`);

export const getFootprintingCropTillagesByPrimaryDataIdAdmin = async (primaryDataId: string): Promise<FootprintingCropTillage[]> =>
  axios.get(`${ADMIN_FOOTPRINTING_URL}/crop-footprints/${primaryDataId}/tillages`);

export const getFootprintingCropFertilizersMineralsByPrimaryDataIdAdmin = async (primaryDataId: string): Promise<FootprintingCropFertilizer[]> =>
  axios.get(`${ADMIN_FOOTPRINTING_URL}/crop-footprints/${primaryDataId}/fertilizers-minerals`, { data: { primaryDataId } });

export const getFootprintingCropFertilizersOrganicsByPrimaryDataIdAdmin = async (primaryDataId: string): Promise<FootprintingCropFertilizer[]> =>
  axios.get(`${ADMIN_FOOTPRINTING_URL}/crop-footprints/${primaryDataId}/fertilizers-organics`, { data: { primaryDataId } });

export const getFootprintingCropPurchasersByFarmIdAdmin = async (farmId: string): Promise<PurchaserData[]> =>
  axios.get(`${ADMIN_FOOTPRINTING_URL}/crop-footprints/purchasers?farmId=${farmId}`);

export const getFootprintingCropSalesByPrimaryDataIdAdmin = async (primaryDataId: string): Promise<CropSaleData[]> =>
  axios.get(`${ADMIN_FOOTPRINTING_URL}/crop-footprints/${primaryDataId}/sales`);

export const setFootprintingFarmPrimaryDataAdmin = async (
  data: Omit<FootprintingFarmPrimaryData, "id">,
  primaryDataId: string
): Promise<FootprintingFarmPrimaryData> => axios.put(`${ADMIN_FOOTPRINTING_URL}/farm-footprints/${primaryDataId}/primary-data`, data);

export const setFootprintingCropPrimaryDataAdmin = async (
  data: Omit<FootprintingCropPrimaryData, "id">,
  primaryDataId?: string
): Promise<FootprintingCropPrimaryData> => axios.put(`${ADMIN_FOOTPRINTING_URL}/crop-footprints/${primaryDataId}/primary-data`, data);

export const setFootprintingFarmResourceConsumptionAdmin = async (
  data: FootprintingFarmResourceConsumption,
  primaryDataId?: string
): Promise<FootprintingFarmResourceConsumption> => axios.put(`${ADMIN_FOOTPRINTING_URL}/farm-footprints/${primaryDataId}/resource-consumption`, data);

export const setFarmLandUseChangesAdmin = async (
  farmId: string,
  data: LandUseChangeRequestPayload,
  year: number,
  range: number
): Promise<FarmLandUseChange[]> =>
  axios.put(`${ADMIN_FOOTPRINTING_URL}/farm-footprints/${farmId}/land-use-change?year=${year ?? ""}&range=${range ?? ""}`, data);

export const setFootprintingCropDryingsByPrimaryDataIdAdmin = async (data: FootprintingCropDrying[], primaryDataId: string) =>
  axios.put(`${ADMIN_FOOTPRINTING_URL}/crop-footprints/${primaryDataId}/dryings`, data);

export const setFootprintingCropSeedingsByPrimaryDataIdAdmin = async (data: FootprintingCropSeeding[], primaryDataId: string) =>
  axios.put(`${ADMIN_FOOTPRINTING_URL}/crop-footprints/${primaryDataId}/seedings`, data);

export const setFootprintingCropTillagesByPrimaryDataIdAdmin = async (data: FootprintingCropTillage[], primaryDataId: string) =>
  axios.put(`${ADMIN_FOOTPRINTING_URL}/crop-footprints/${primaryDataId}/tillages`, data);

export const setFootprintingCropFertilizersMineralsAdmin = async (
  data: FootprintingCropFertilizer[],
  primaryDataId: string
): Promise<FootprintingCropFertilizer[]> => axios.put(`${ADMIN_FOOTPRINTING_URL}/crop-footprints/${primaryDataId}/fertilizers-minerals`, data);

export const setFootprintingCropPlantProtectionAdmin = async (
  data: FootprintingFarmCropPlantProtectionPayload,
  primaryDataId?: string
): Promise<UploadablePlantProtection[]> =>
  axios.put(`${ADMIN_FOOTPRINTING_URL}/crop-footprints/${primaryDataId}/plant-protection`, data.selectedPlantProtection);

export const setFootprintingCropSalesAdmin = async (data: FootprintingCropSalesPayload, primaryDataId: string): Promise<CropSaleData[]> =>
  axios.put(`${ADMIN_FOOTPRINTING_URL}/crop-footprints/${primaryDataId}/sales`, data);

export const setFootprintingCropFertilizersOrganicsAdmin = async (
  data: FootprintingCropFertilizer[],
  primaryDataId?: string
): Promise<FootprintingCropFertilizer[]> => axios.put(`${ADMIN_FOOTPRINTING_URL}/crop-footprints/${primaryDataId}/fertilizers-organics`, data);

/** DAIRY */

export const getDairyFootprintByYearAdmin = async (farmId: string, year: number): Promise<DairyFootprintReturnBody> =>
  // @ts-expect-error custom params can be passed in axios config
  axios.get(`${ADMIN_FOOTPRINTING_URL}/dairy-footprints`, { data: { year, farmId }, hideErrorMessage: true });

export const getCalculatedDairyFootprintByYearAdmin = async (farmId: string, year: number): Promise<CalculatedDairyFootprintResponse> =>
  // @ts-expect-error custom params can be passed in axios config
  axios.get(`${ADMIN_FOOTPRINTING_URL}/dairy-footprints/footprint-calculation`, { data: { farmId, year }, hideErrorMessage: true });

export const getFootprintingDairyPrimaryDataByIdAdmin = async (primaryDataId: string): Promise<FootprintingDairyPrimaryData> =>
  // @ts-expect-error custom params can be passed in axios config
  axios.get(`${ADMIN_FOOTPRINTING_URL}/dairy-footprints/${primaryDataId}/primary-data`, { hideErrorMessage: true });

export const setFootprintingDairyPrimaryDataAdmin = async (
  data: Omit<FootprintingDairyPrimaryData, "id">,
  primaryDataId?: string,
  options?: CreateFarmPrimaryDataQueryParams
): Promise<FootprintingDairyPrimaryData> => {
  if (primaryDataId) {
    return axios.put(`${ADMIN_FOOTPRINTING_URL}/dairy-footprints/${primaryDataId}/primary-data`, data);
  }

  const autofillQuery = options?.autofillYear === undefined ? "" : `?autofillYear=${options.autofillYear}`;
  return axios.post(`${ADMIN_FOOTPRINTING_URL}/dairy-footprints/primary-data${autofillQuery}`, data);
};

export const deleteFootprintingDairyByPrimaryDataIdAdmin = async (primaryDataId: string) =>
  axios.delete(`${ADMIN_FOOTPRINTING_URL}/dairy-footprints/${primaryDataId}/primary-data`);

export const getDairyHerdSizeAdmin = async (primaryDataId: string): Promise<FootprintingDairyHerdSize[]> =>
  axios.get(`${ADMIN_FOOTPRINTING_URL}/dairy-footprints/${primaryDataId}/herd-sizes`);

export const setDairyHerdSizeAdmin = async (primaryDataId: string, data: UploadableHerdSize[]): Promise<FootprintingDairyHerdSize[]> =>
  axios.put(`${ADMIN_FOOTPRINTING_URL}/dairy-footprints/${primaryDataId}/herd-sizes`, data);

export const getDairyHerdDetailsAdmin = async (primaryDataId: string): Promise<FootprintingDairyHerdDetails> =>
  axios.get(`${ADMIN_FOOTPRINTING_URL}/dairy-footprints/${primaryDataId}/herd-details`);

export const setDairyHerdDetailsAdmin = async (
  data: Omit<FootprintingDairyHerdDetails, "id">,
  primaryDataId?: string
): Promise<FootprintingDairyHerdDetails> => {
  if (primaryDataId) {
    return axios.put(`${ADMIN_FOOTPRINTING_URL}/dairy-footprints/${primaryDataId}/herd-details`, data);
  }

  return axios.post(`${ADMIN_FOOTPRINTING_URL}/dairy-footprints/herd-details`, data);
};

export const getDairyCowSalesAdmin = async (primaryDataId: string): Promise<FootprintingDairyCowSales> =>
  axios.get(`${ADMIN_FOOTPRINTING_URL}/dairy-footprints/${primaryDataId}/cow-sales`);

export const setDairyCowSalesAdmin = async (primaryDataId: string, data: UploadableCowSales): Promise<FootprintingDairyCowSales> =>
  axios.put(`${ADMIN_FOOTPRINTING_URL}/dairy-footprints/${primaryDataId}/cow-sales`, data);

export const getFootprintingDairyRefrigerantUsageAdmin = async (primaryDataId: string): Promise<FootprintingDairyRefrigerantUsage[]> =>
  axios.get(`${ADMIN_FOOTPRINTING_URL}/dairy-footprints/${primaryDataId}/refrigerant-usage`);

export const setFootprintingDairyRefrigerantUsageAdmin = async (
  data: UploadableRefrigerant[],
  primaryDataId?: string
): Promise<FootprintingDairyRefrigerantUsage[]> => axios.put(`${ADMIN_FOOTPRINTING_URL}/dairy-footprints/${primaryDataId}/refrigerant-usage`, data);

export const getFootprintingDairyFeedAdditiveAdmin = async (primaryDataId: string): Promise<UploadableFeedAdditive[]> =>
  axios.get(`${ADMIN_FOOTPRINTING_URL}/dairy-footprints/${primaryDataId}/feed-additives`);

export const setFootprintingDairyFeedAdditiveAdmin = async (
  data: FootprintingDairyFeedAdditivePayload,
  primaryDataId?: string
): Promise<UploadableFeedAdditive[]> => axios.put(`${ADMIN_FOOTPRINTING_URL}/dairy-footprints/${primaryDataId}/feed-additives`, data.selectedFeedAdditive);

export const getFootprintingDairyGrasslandFertiliserAdmin = async (primaryDataId: string): Promise<UploadableGrasslandFertiliser[]> =>
  axios.get(`${ADMIN_FOOTPRINTING_URL}/dairy-footprints/${primaryDataId}/grassland-fertilisers`);

export const setFootprintingDairyGrasslandFertiliserAdmin = async (
  data: FootprintingDairyGrasslandFertiliserPayload,
  primaryDataId: string
): Promise<UploadableGrasslandFertiliser[]> =>
  axios.put(`${ADMIN_FOOTPRINTING_URL}/dairy-footprints/${primaryDataId}/grassland-fertilisers`, data.selectedGrasslandFertilisers);

export const getDairyFeedInformationAdmin = async (primaryDataId: string): Promise<FootprintingDairyFeedInformation[]> =>
  axios.get(`${ADMIN_FOOTPRINTING_URL}/dairy-footprints/${primaryDataId}/feed-informations`);

export const setDairyFeedInformationAdmin = async (primaryDataId: string, data: UploadableFeedInformation[]): Promise<FootprintingDairyFeedInformation> =>
  axios.put(`${ADMIN_FOOTPRINTING_URL}/dairy-footprints/${primaryDataId}/feed-informations`, data);

export const getFootprintingDairyFeedProductionAdmin = async (feedInformationId: string): Promise<DairyFeedProduction | null> =>
  axios.get(`${ADMIN_FOOTPRINTING_URL}/dairy-footprints/dairy-feed-productions/${feedInformationId}`);

export const setFootprintingDairyFeedProductionAdmin = async (feedInformationId: string, data: DairyFeedProduction): Promise<DairyFeedProduction> =>
  axios.put(`${ADMIN_FOOTPRINTING_URL}/dairy-footprints/dairy-feed-productions/${feedInformationId}`, data);

export const getFootprintingDairyManureStorageAdmin = async (primaryDataId: string): Promise<UploadableManureStorage[]> =>
  axios.get(`${ADMIN_FOOTPRINTING_URL}/dairy-footprints/${primaryDataId}/manure-storages`);

export const setFootprintingDairyManureStorageAdmin = async (
  data: FootprintingDairyManureStoragePayload,
  primaryDataId?: string
): Promise<UploadableManureStorage[]> => axios.put(`${ADMIN_FOOTPRINTING_URL}/dairy-footprints/${primaryDataId}/manure-storages`, data.selectedManureStorage);

export const getFootprintingDairyManureAdditiveAdmin = async (primaryDataId: string): Promise<UploadableManureAdditive[]> =>
  axios.get(`${ADMIN_FOOTPRINTING_URL}/dairy-footprints/${primaryDataId}/manure-additives`);

export const setFootprintingDairyManureAdditiveAdmin = async (
  data: FootprintingDairyManureAdditivePayload,
  primaryDataId?: string
): Promise<UploadableManureAdditive[]> =>
  axios.put(`${ADMIN_FOOTPRINTING_URL}/dairy-footprints/${primaryDataId}/manure-additives`, data.selectedManureAdditive);

/** BEEF */

export const getBeefFootprintByYearAdmin = async (farmId: string, year: number): Promise<BeefFootprintReturnBody> =>
  // @ts-expect-error custom params can be passed in axios config
  axios.get(`${ADMIN_FOOTPRINTING_URL}/beef-footprints`, { data: { farmId, year }, hideErrorMessage: true });

export const getCalculatedBeefFootprintByYearAdmin = async (farmId: string, year: number): Promise<CalculatedBeefFootprintResponse> =>
  // @ts-expect-error custom params can be passed in axios config
  axios.get(`${ADMIN_FOOTPRINTING_URL}/beef-footprints/footprint-calculation`, { data: { farmId, year }, hideErrorMessage: true });

export const getFootprintingBeefPrimaryDataByIdAdmin = async (primaryDataId: string): Promise<FootprintingBeefPrimaryData> =>
  // @ts-expect-error custom params can be passed in axios config
  axios.get(`${ADMIN_FOOTPRINTING_URL}/beef-footprints/${primaryDataId}/primary-data`, { hideErrorMessage: true });

export const setFootprintingBeefPrimaryDataAdmin = async (
  data: Omit<FootprintingBeefPrimaryData, "id">,
  primaryDataId?: string,
  options?: CreateFarmPrimaryDataQueryParams
): Promise<FootprintingBeefPrimaryData> => {
  if (primaryDataId) {
    return axios.put(`${ADMIN_FOOTPRINTING_URL}/beef-footprints/${primaryDataId}/primary-data`, data);
  }

  const autofillQuery = options?.autofillYear === undefined ? "" : `?autofillYear=${options.autofillYear}`;
  return axios.post(`${ADMIN_FOOTPRINTING_URL}/beef-footprints/primary-data${autofillQuery}`, data);
};

export const deleteFootprintingBeefByPrimaryDataIdAdmin = async (primaryDataId: string) =>
  axios.delete(`${ADMIN_FOOTPRINTING_URL}/beef-footprints/${primaryDataId}/primary-data`);

export const getBeefHerdSizeAdmin = async (primaryDataId: string): Promise<FootprintingBeefHerdSize[]> =>
  axios.get(`${ADMIN_FOOTPRINTING_URL}/beef-footprints/${primaryDataId}/herd-sizes`);

export const setBeefHerdSizeAdmin = async (primaryDataId: string, data: UploadableBeefHerdSize[]): Promise<FootprintingBeefHerdSize[]> =>
  axios.put(`${ADMIN_FOOTPRINTING_URL}/beef-footprints/${primaryDataId}/herd-sizes`, data);

export const getBeefHerdDetailsAdmin = async (primaryDataId: string): Promise<FootprintingBeefHerdDetails> =>
  axios.get(`${ADMIN_FOOTPRINTING_URL}/beef-footprints/${primaryDataId}/herd-details`);

export const setBeefHerdDetailsAdmin = async (primaryDataId: string, data: Omit<FootprintingBeefHerdDetails, "id">): Promise<FootprintingBeefHerdDetails> =>
  axios.put(`${ADMIN_FOOTPRINTING_URL}/beef-footprints/${primaryDataId}/herd-details`, data);

export const getBeefFeedAdditiveAdmin = async (primaryDataId: string): Promise<UploadableBeefFeedAdditive[]> =>
  axios.get(`${ADMIN_FOOTPRINTING_URL}/beef-footprints/${primaryDataId}/feed-additives`);

export const setBeefFeedAdditiveAdmin = async (primaryDataId: string, data: UploadableBeefFeedAdditive[]): Promise<UploadableBeefFeedAdditive[]> =>
  axios.put(`${ADMIN_FOOTPRINTING_URL}/beef-footprints/${primaryDataId}/feed-additives`, data);

export const getBeefFeedInformationAdmin = async (primaryDataId: string): Promise<FootprintingBeefFeedInformation[]> =>
  axios.get(`${ADMIN_FOOTPRINTING_URL}/beef-footprints/${primaryDataId}/feed-informations`);

export const setBeefFeedInformationAdmin = async (primaryDataId: string, data: UploadableBeefFeedInformation[]): Promise<FootprintingBeefFeedInformation[]> =>
  axios.put(`${ADMIN_FOOTPRINTING_URL}/beef-footprints/${primaryDataId}/feed-informations`, data);

export const getBeefGrasslandFertiliserAdmin = async (primaryDataId: string): Promise<FootprintingBeefGrasslandFertiliser[]> =>
  axios.get(`${ADMIN_FOOTPRINTING_URL}/beef-footprints/${primaryDataId}/grassland-fertilisers`);

export const setBeefGrasslandFertiliserAdmin = async (
  payload: FootprintingBeefGrasslandFertiliserPayload,
  primaryDataId: string
): Promise<FootprintingBeefGrasslandFertiliser[]> =>
  axios.put(`${ADMIN_FOOTPRINTING_URL}/beef-footprints/${primaryDataId}/grassland-fertilisers`, payload.selectedGrasslandFertilisers);

export const getBeefManureStorageAdmin = async (primaryDataId: string): Promise<UploadableBeefManureStorage[]> =>
  axios.get(`${ADMIN_FOOTPRINTING_URL}/beef-footprints/${primaryDataId}/manure-storages`);

export const setBeefManureStorageAdmin = async (primaryDataId: string, data: UploadableBeefManureStorage[]): Promise<UploadableBeefManureStorage[]> =>
  axios.put(`${ADMIN_FOOTPRINTING_URL}/beef-footprints/${primaryDataId}/manure-storages`, data);

export const getFootprintingBeefManureAdditiveAdmin = async (primaryDataId: string): Promise<UploadableManureAdditive[]> =>
  axios.get(`${ADMIN_FOOTPRINTING_URL}/beef-footprints/${primaryDataId}/manure-additives`);

export const setFootprintingBeefManureAdditiveAdmin = async (
  data: FootprintingBeefManureAdditivePayload,
  primaryDataId?: string
): Promise<UploadableManureAdditive[]> => axios.put(`${ADMIN_FOOTPRINTING_URL}/beef-footprints/${primaryDataId}/manure-additives`, data.selectedManureAdditive);

export const getFootprintingBeefFeedProductionAdmin = async (feedInformationId: string): Promise<BeefFeedProduction | null> =>
  axios.get(`${ADMIN_FOOTPRINTING_URL}/beef-footprints/beef-feed-productions/${feedInformationId}`);

export const setFootprintingBeefFeedProductionAdmin = async (feedInformationId: string, data: BeefFeedProduction): Promise<BeefFeedProduction> =>
  axios.put(`${ADMIN_FOOTPRINTING_URL}/beef-footprints/beef-feed-productions/${feedInformationId}`, data);

/** PORK */

export const getPorkFootprintByYearAdmin = async (farmId: string, year: number): Promise<PorkFootprintReturnBody> =>
  // @ts-expect-error custom params can be passed in axios config
  axios.get(`${ADMIN_FOOTPRINTING_URL}/pork-footprints`, { data: { farmId, year }, hideErrorMessage: true });

export const getCalculatedPorkFootprintByYearAdmin = async (farmId: string, year: number): Promise<CalculatedPorkFootprintResponse> =>
  // @ts-expect-error custom params can be passed in axios config
  axios.get(`${ADMIN_FOOTPRINTING_URL}/pork-footprints/footprint-calculation`, { data: { farmId, year }, hideErrorMessage: true });

export const getFootprintingPorkPrimaryDataByIdAdmin = async (primaryDataId: string): Promise<FootprintingPorkPrimaryData> =>
  // @ts-expect-error custom params can be passed in axios config
  axios.get(`${ADMIN_FOOTPRINTING_URL}/pork-footprints/${primaryDataId}/primary-data`, { hideErrorMessage: true });

export const setFootprintingPorkPrimaryDataAdmin = async (
  data: Partial<Omit<FootprintingPorkPrimaryData, "id">>,
  primaryDataId?: string,
  options?: CreateFarmPrimaryDataQueryParams
): Promise<FootprintingPorkPrimaryData> => {
  if (primaryDataId) {
    return axios.put(`${ADMIN_FOOTPRINTING_URL}/pork-footprints/${primaryDataId}/primary-data`, data);
  }

  const autofillQuery = options?.autofillYear === undefined ? "" : `?autofillYear=${options.autofillYear}`;
  return axios.post(`${ADMIN_FOOTPRINTING_URL}/pork-footprints/primary-data${autofillQuery}`, data);
};

export const deleteFootprintingPorkByPrimaryDataIdAdmin = async (primaryDataId: string) =>
  axios.delete(`${ADMIN_FOOTPRINTING_URL}/pork-footprints/${primaryDataId}/primary-data`);

export const getPorkHerdDetailsAdmin = async (primaryDataId: string): Promise<FootprintingPorkHerdDetails> =>
  axios.get(`${ADMIN_FOOTPRINTING_URL}/pork-footprints/${primaryDataId}/herd-details`);

export const setPorkHerdDetailsAdmin = async (
  data: Partial<Omit<FootprintingPorkHerdDetails, "id" | "primaryDataId">>,
  primaryDataId?: string
): Promise<FootprintingPorkHerdDetails> => {
  if (primaryDataId) {
    return axios.put(`${ADMIN_FOOTPRINTING_URL}/pork-footprints/${primaryDataId}/herd-details`, data);
  }

  return axios.post(`${ADMIN_FOOTPRINTING_URL}/pork-footprints/herd-details`, data);
};

export const getPorkFeedInformationAdmin = async (primaryDataId: string): Promise<UploadablePorkFeedInformation[]> =>
  axios.get(`${ADMIN_FOOTPRINTING_URL}/pork-footprints/${primaryDataId}/feed-informations`);

export const setPorkFeedInformationAdmin = async (primaryDataId: string, data: UploadablePorkFeedInformation[]): Promise<FootprintingPorkFeedInformation> =>
  axios.put(`${ADMIN_FOOTPRINTING_URL}/pork-footprints/${primaryDataId}/feed-informations`, data);

export const getFootprintingPorkFeedProductionAdmin = async (feedInformationId: string): Promise<PorkFeedProduction | null> =>
  axios.get(`${ADMIN_FOOTPRINTING_URL}/pork-footprints/pork-feed-productions/${feedInformationId}`);

export const setFootprintingPorkFeedProductionAdmin = async (feedInformationId: string, data: PorkFeedProduction): Promise<PorkFeedProduction> =>
  axios.put(`${ADMIN_FOOTPRINTING_URL}/pork-footprints/pork-feed-productions/${feedInformationId}`, data);

export const getFootprintingPorkManureStorageAdmin = async (primaryDataId: string): Promise<UploadableManureStorage[]> =>
  axios.get(`${ADMIN_FOOTPRINTING_URL}/pork-footprints/${primaryDataId}/manure-storages`);

export const setFootprintingPorkManureStorageAdmin = async (
  data: FootprintingPorkManureStoragePayload,
  primaryDataId?: string
): Promise<UploadableManureStorage[]> => axios.put(`${ADMIN_FOOTPRINTING_URL}/pork-footprints/${primaryDataId}/manure-storages`, data.selectedManureStorage);

export const getFootprintingPorkManureAdditiveAdmin = async (primaryDataId: string): Promise<UploadableManureAdditive[]> =>
  axios.get(`${ADMIN_FOOTPRINTING_URL}/pork-footprints/${primaryDataId}/manure-additives`);

export const setFootprintingPorkManureAdditiveAdmin = async (
  data: FootprintingPorkManureAdditivePayload,
  primaryDataId?: string
): Promise<UploadableManureAdditive[]> => axios.put(`${ADMIN_FOOTPRINTING_URL}/pork-footprints/${primaryDataId}/manure-additives`, data.selectedManureAdditive);

export const setPorkPigletSourcingAdmin = async (
  data: FootprintingPorkPigletSourcingPayload,
  primaryDataId: string
): Promise<FootprintingPorkPigletSourcingPayload> => axios.put(`${ADMIN_FOOTPRINTING_URL}/pork-footprints/${primaryDataId}/piglet-sourcing`, data);

export const setPorkStablesAdmin = async (data: FootprintingPorkStablesPayload, primaryDataId: string): Promise<FootprintingPorkStablesPayload> =>
  axios.put(`${ADMIN_FOOTPRINTING_URL}/pork-footprints/${primaryDataId}/stables`, data);

/** PIGLET */

export const getPigletFootprintByYearAdmin = async (farmId: string, year: number): Promise<PigletFootprintReturnBody> =>
  // @ts-expect-error custom params can be passed in axios config
  axios.get(`${ADMIN_FOOTPRINTING_URL}/piglet-footprints`, { data: { farmId, year }, hideErrorMessage: true });

export const getCalculatedPigletFootprintByYearAdmin = async (farmId: string, year: number): Promise<CalculatedPigletFootprintResponse> =>
  // @ts-expect-error custom params can be passed in axios config
  axios.get(`${ADMIN_FOOTPRINTING_URL}/piglet-footprints/footprint-calculation`, { data: { farmId, year }, hideErrorMessage: true });

export const getFootprintingPigletPrimaryDataByIdAdmin = async (primaryDataId: string): Promise<FootprintingPigletPrimaryData> =>
  // @ts-expect-error custom params can be passed in axios config
  axios.get(`${ADMIN_FOOTPRINTING_URL}/piglet-footprints/${primaryDataId}/primary-data`, { hideErrorMessage: true });

export const setFootprintingPigletPrimaryDataAdmin = async (
  data: Partial<Omit<FootprintingPigletPrimaryData, "id">>,
  primaryDataId?: string,
  options?: CreateFarmPrimaryDataQueryParams
): Promise<FootprintingPigletPrimaryData> => {
  if (primaryDataId) {
    return axios.put(`${ADMIN_FOOTPRINTING_URL}/piglet-footprints/${primaryDataId}/primary-data`, data);
  }

  const autofillQuery = options?.autofillYear === undefined ? "" : `?autofillYear=${options.autofillYear}`;
  return axios.post(`${ADMIN_FOOTPRINTING_URL}/piglet-footprints/primary-data${autofillQuery}`, data);
};

export const deleteFootprintingPigletByPrimaryDataIdAdmin = async (primaryDataId: string) =>
  axios.delete(`${ADMIN_FOOTPRINTING_URL}/piglet-footprints/${primaryDataId}/primary-data`);

export const getPigletHerdDetailsAdmin = async (primaryDataId: string): Promise<FootprintingPigletHerdDetails> =>
  axios.get(`${ADMIN_FOOTPRINTING_URL}/piglet-footprints/${primaryDataId}/herd-details`);

export const setPigletHerdDetailsAdmin = async (
  data: Partial<Omit<FootprintingPigletHerdDetails, "id" | "primaryDataId">>,
  primaryDataId?: string
): Promise<FootprintingPigletHerdDetails> => {
  if (primaryDataId) {
    return axios.put(`${ADMIN_FOOTPRINTING_URL}/piglet-footprints/${primaryDataId}/herd-details`, data);
  }

  return axios.post(`${ADMIN_FOOTPRINTING_URL}/piglet-footprints/herd-details`, data);
};

export const getPigletFeedInformationAdmin = async (primaryDataId: string): Promise<UploadablePigletFeedInformation[]> =>
  axios.get(`${ADMIN_FOOTPRINTING_URL}/piglet-footprints/${primaryDataId}/feed-informations`);

export const setPigletFeedInformationAdmin = async (
  primaryDataId: string,
  data: UploadablePigletFeedInformation[]
): Promise<FootprintingPigletFeedInformation> => axios.put(`${ADMIN_FOOTPRINTING_URL}/piglet-footprints/${primaryDataId}/feed-informations`, data);

export const getFootprintingPigletFeedProductionAdmin = async (feedInformationId: string): Promise<PigletFeedProduction | null> =>
  axios.get(`${ADMIN_FOOTPRINTING_URL}/piglet-footprints/piglet-feed-productions/${feedInformationId}`);

export const setFootprintingPigletFeedProductionAdmin = async (feedInformationId: string, data: PigletFeedProduction): Promise<PigletFeedProduction> =>
  axios.put(`${ADMIN_FOOTPRINTING_URL}/piglet-footprints/piglet-feed-productions/${feedInformationId}`, data);

export const getFootprintingPigletManureStorageAdmin = async (primaryDataId: string): Promise<UploadableManureStorage[]> =>
  axios.get(`${ADMIN_FOOTPRINTING_URL}/piglet-footprints/${primaryDataId}/manure-storages`);

export const setFootprintingPigletManureStorageAdmin = async (
  data: FootprintingPigletManureStoragePayload,
  primaryDataId?: string
): Promise<UploadableManureStorage[]> => axios.put(`${ADMIN_FOOTPRINTING_URL}/piglet-footprints/${primaryDataId}/manure-storages`, data.selectedManureStorage);

export const getFootprintingPigletManureAdditiveAdmin = async (primaryDataId: string): Promise<UploadableManureAdditive[]> =>
  axios.get(`${ADMIN_FOOTPRINTING_URL}/piglet-footprints/${primaryDataId}/manure-additives`);

export const setFootprintingPigletManureAdditiveAdmin = async (
  data: FootprintingPigletManureAdditivePayload,
  primaryDataId?: string
): Promise<UploadableManureAdditive[]> =>
  axios.put(`${ADMIN_FOOTPRINTING_URL}/piglet-footprints/${primaryDataId}/manure-additives`, data.selectedManureAdditive);

export const setPigletStablesAdmin = async (data: FootprintingPigletStablesPayload, primaryDataId: string): Promise<FootprintingPigletStablesPayload> =>
  axios.put(`${ADMIN_FOOTPRINTING_URL}/piglet-footprints/${primaryDataId}/stables`, data);
